import React, { useEffect } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

import getRules from '../../../../api/getRules'
import ListAsync from '../../LookupsList/ListAsync'
import { PropScheduleType, ScheduleContent, ScheduleContentBox } from './getScheduleComponent'
import { OptionType } from '../../LookupsList/LookupSelect'
import type { Rules } from '../../../../common/types/api/RuleResponse'
import { CustomListAsyncStyles } from '../../ReportContent/components/GalleryEditor/galleryEditor'

import { ThrottleMS } from '../../../../common/components/ConvertUom/types/ThrottleMS'
import {
    defaultThrottleUOMUnit,
    isValidUomUnit,
    parseFormatTimeUom,
    defaultThrottleValue
} from '../../../../../js/common/components/ConvertUom/types/throttleMSHelper'
import { FormatTimeUom } from '../../../../../js/common/components/ConvertUom/types/types'

export function ScheduleRule({ scheduleType, settings, updateSettings }: PropScheduleType): JSX.Element {
    useEffect(() => {
        if (settings?.throttleAlarm == undefined) {
            updateSettings({
                ...settings,

                throttleAlarm: defaultThrottleValue,
                throttleAlarmUomFormat: defaultThrottleUOMUnit
            })
        }
    }, [settings])

    return (
        <ScheduleContent className={'scheduling--recipientGroups__selectInput'}>
            <ScheduleContentBox>
                <label>
                    {i18n('Alert Rule')}
                    <span
                        className={'GESettingsSection__Block--requiredField'}
                        style={{
                            color: '#D9534F',
                            fontSize: '13px  '
                        }}
                    >
                        {' '}
                        *{' '}
                    </span>
                </label>
                <ListAsync<Rules[]>
                    placeholder={i18n('Select Alert Rule')}
                    getApi={getRules}
                    selectValueById={true}
                    isMulti={false}
                    value={settings?.ruleId ? { label: '', value: settings?.ruleId } : null}
                    onChange={option => {
                        const firstOption = (option[0] || option || { value: '', label: '' }) as OptionType
                        updateSettings({
                            ...settings,
                            ruleId: String(firstOption?.value || '')
                        })
                    }}
                    callback={rules => rules.map(({ id, name }) => ({ label: name, value: `${id}` }))}
                    disabled={false}
                    editMode={true}
                    styles={CustomListAsyncLocal}
                    isClearable={false}
                />
                <ThrottleContainer>
                    <ThrottleMS
                        current={{
                            value: settings?.throttleAlarm,
                            formatTimeUom: FormatTimeUom[isValidUomUnit(settings?.throttleAlarmUomFormat) ? settings?.throttleAlarmUomFormat : defaultThrottleUOMUnit]
                        }}
                        onChangeValue={value => {
                            let newValue = value?.target?.value
                            if (
                                newValue === undefined &&
                                newValue.trim() === "" &&
                                Number.isNaN(newValue)
                            ) {
                                newValue = 0
                            }
                            updateSettings({
                                ...settings,
                                throttleAlarm: parseFormatTimeUom(
                                    newValue,
                                    FormatTimeUom[isValidUomUnit(settings?.throttleAlarmUomFormat) ? settings?.throttleAlarmUomFormat : defaultThrottleUOMUnit],
                                    FormatTimeUom.m
                                )
                            })
                        }}
                        onChangeUom={(uom: string) => {
                            updateSettings({
                                ...settings,
                                throttleAlarmUomFormat: uom?.value
                            })
                        }}
                    />
                </ThrottleContainer>
            </ScheduleContentBox>
        </ScheduleContent>
    )
}

export const ThrottleContainer = styled.div`
    .throttleInput {
        height: 38px;
        width: 65%; // tamanho do input
        border-right: none;
        border-radius: 3px 0 0 3px;

        :focus {
            border-right: 1px solid var(--blue-500);
        }
    }
`

const CustomListAsyncLocal = {
    ...CustomListAsyncStyles,
    menu: styles => ({
        ...styles,
        marginTop: '0px'
    })
}
